/**
 * Helpers for `GET_PROFILE` → `data.getProfile.profile` (user + nested `store`).
 */

export function getProfileFromQuery(data) {
  return data?.getProfile?.profile ?? null;
}

export function getStoreFromQuery(data) {
  return getProfileFromQuery(data)?.store ?? null;
}

/** Treat null, undefined, and "" as empty (API often returns ""). */
export function hasProfileValue(value) {
  if (value == null) return false;
  if (typeof value === "string") return value.trim().length > 0;
  if (Array.isArray(value)) return value.length > 0;
  return true;
}

/** Normalize store media URLs for previews and mutation payloads. */
export function normalizeMediaUrl(value) {
  if (value == null) return null;
  const trimmed = String(value).trim();
  return trimmed || null;
}

export function getDisplayName(profile) {
  if (!profile) return "there";
  const storeName = profile.store?.storeName?.trim();
  if (storeName) return storeName;
  const first = profile.firstName?.trim();
  if (first) return first;
  return "there";
}

export function getStoreCoordinates(profile) {
  const coords = profile?.coordinates;
  if (!coords) return { latitude: null, longitude: null };
  return {
    latitude: coords.lat ?? coords.latitude ?? null,
    longitude: coords.long ?? coords.longitude ?? null,
  };
}
